import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../_shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { RequestAccessModalComponent } from './request-access-modal/request-access-modal.component';
import { RequestAccessPageComponent } from './request-access-page/request-access-page.component';

@NgModule({
  declarations: [
    DashboardComponent,
    WelcomeComponent,
    RequestAccessModalComponent,
    RequestAccessPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  exports: [RequestAccessPageComponent],
})
export class InsightsModule { }
